import $ from "jquery"

/**
 * Scripts for matchHeight sections
 */
$('.js-match-height').matchHeight();

/**
 * Scripts for selling point section
 */
const sellingPoint = $('.js-selling-point-item');

sellingPoint.each(function(){
    $(this).on('click', function(){
        const sellingPointLeftContent = $(this).closest('.selling-point__item').find('.selling-point__description').html();
        
        $('.js-selling-point-populate-content').html(sellingPointLeftContent);
        $(sellingPoint).removeClass('active');
        $(this).addClass('active');
    });
});

/**
 * Scripts for popup form
 */
const defaultModal = $('.ecommerce-popup__container.default');
const thankyouModal = $('.ecommerce-popup__container.thank-you');
const modal = $('.js-ecommerce-popup-form, .js-ecommerce-popup-overlay');

if(defaultModal.length || thankyouModal.length || modal.length){
  $(window).on('scroll', function() {
    window.setTimeout(function(){
      // First check, if localStorage is supported.
      if (window.localStorage) {
        // Get the expiration date of the previous popup.
        var nextPopup = localStorage.getItem( 'emailStorage' );

        if (nextPopup > new Date()) {
            return;
        }

        // Store the expiration date of the current popup in localStorage.
        var expires = new Date();
        expires = expires.setHours(expires.getHours() + 24);

        localStorage.setItem( 'emailStorage', expires );
      }

      if ($('.js-ecommerce-popup-form')) {
        modal.toggle();
        $('body').toggleClass('o-hidden');
        modal.addClass('active');
      }
    }, 500);
  });

  $('.js-close').on('click', function() {
    modal.toggle();
    modal.removeClass('active');
    $('body').toggleClass('o-hidden');
  });

  document.querySelector('.ecommerce-popup form').addEventListener('wpcf7mailsent', function(event) {
    defaultModal.removeClass('d-flex');
    defaultModal.addClass('d-none');
    thankyouModal.addClass('d-flex');
    thankyouModal.removeClass('d-none');
    setTimeout( function() {
      modal.removeClass('active');
    }, 2000);
  }, false);
}